/**
 * `"MM/AAAA"` de cada mês entre as duas pontas do período, inclusive.
 *
 * Aritmética em UTC, que é como o período é construído (`Date.UTC(ano, mês, 1)` no
 * seletor e no storage). Ler o mês em horário LOCAL de uma meia-noite UTC cai no mês
 * anterior em qualquer fuso negativo — é por isso que a tabela da Projeção soma um mês
 * às duas pontas antes de ler, uma compensação que só fecha em fuso negativo.
 *
 * Compartilhado pela tabela da EAP e pelo gráfico da curva: os dois recortam o mesmo
 * período, e duas implementações divergiriam no primeiro fuso que não fosse o nosso.
 */
const monthsBetween = (beginAt, endAt) => {
  const months = [];
  const start = new Date(beginAt);
  const end = new Date(endAt);
  if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime()))
    return months;
  let year = start.getUTCFullYear();
  let month = start.getUTCMonth();
  const endYear = end.getUTCFullYear();
  const endMonth = end.getUTCMonth();
  while (year < endYear || (year === endYear && month <= endMonth)) {
    months.push(`${String(month + 1).padStart(2, "0")}/${year}`);
    month += 1;
    if (month > 11) {
      month = 0;
      year += 1;
    }
  }
  return months;
};

export default monthsBetween;
